import {
  FormControl,
  FormLabel,
  TextField,
  Box,
  Stack,
  Button,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

interface ProfessionalSummarySectionProps {
  professionalSummary: string;
  setProfessionalSummary: React.Dispatch<React.SetStateAction<string>>;
  summaryFields: string[];
  handleUpdate: (e: any, index: number) => void;
  addField: () => void;
  removeField: (index: number) => void;
  error: string;
  removeErrorMessage: (field: string) => void;
}

export const ProfessionalSummarySection: React.FC<
  ProfessionalSummarySectionProps
> = ({
  professionalSummary,
  setProfessionalSummary,
  summaryFields,
  handleUpdate,
  addField,
  removeField,
  error,
  removeErrorMessage,
}) => {
  const [hoveredField, setHoveredField] = useState<number | null>(null);

  return (
    <FormControl>
      <FormLabel htmlFor="professionalSummary">Professional Summary</FormLabel>
      <TextField
        id="professionalSummary"
        type="text"
        name="professionalSummary"
        placeholder="Professional Summary"
        error={!!error}
        helperText={error}
        onChange={(e) => {
          removeErrorMessage("professionalSummary");
          setProfessionalSummary(e.target.value);
        }}
        value={professionalSummary}
        multiline
        minRows={4}
        color="primary"
      />
      <Box>
        <Stack spacing={2} my={2}>
          {summaryFields.map((field, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
              onMouseEnter={() => setHoveredField(index)}
              onMouseLeave={() => setHoveredField(null)}
            >
              <TextField
                fullWidth
                multiline
                variant="outlined"
                value={field}
                onChange={(e) => handleUpdate(e.target.value, index)}
              />
              {hoveredField === index && (
                <IconButton onClick={() => removeField(index)}>
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          ))}
        </Stack>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={addField}
          fullWidth
        >
          Add Additional Information
        </Button>
      </Box>
    </FormControl>
  );
};
